import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { RootState, store } from "../../redux/app/store";
import { setConnector, setConnectors, setLocalMcpTools } from "../../redux/features/app/toolSlice";
import { Connector, IMCPTool, UserConnector, UserConnectorListResponse } from "../models/app/mcp/Tool";
import { ConnectorService } from "../services/ConnectorService";
import { outlookAuthService } from "../services/OutlookAuthService";

export const useApp = () => {
  const dispatch = useAppDispatch();
  const { localMcpTools } = useAppSelector((state: RootState) => state.tools);

  const connectorService = new ConnectorService();

  const changedMcpToolState = (server: string, toolName: string, enabled: boolean) => {
    const tool = localMcpTools[server].find(c => c.id == toolName) as IMCPTool;
    if (tool) {
      const updatedData = {
        ...localMcpTools,
        [server]: localMcpTools[server].map(t =>
          t.name === tool.name
            ? { ...t, enabled: enabled }
            : t
        )
      };
      dispatch(setLocalMcpTools(updatedData));
      if (window.electron?.isElectron) {
        window.electron.reqeustMCPToolStateChange(updatedData);
      }
    }
  }

  const changedMcpServerState = (name: string, enabled: boolean) => {
    const server = localMcpTools[name];
    if (server) {
      const updatedData = {
        ...localMcpTools,
        [name]: server.map(t => ({
          ...t,
          enabled: enabled
        }))
      };
      dispatch(setLocalMcpTools(updatedData));
      if (window.electron?.isElectron) {
        window.electron.reqeustMCPToolStateChange(updatedData);
      }
    }
  }

  const getUserConnectors = async (): Promise<UserConnectorListResponse> => {
    const tools = await connectorService.getUserConnectors();
    dispatch(setConnectors(tools));
    return tools;
  }

  const getAvailableConnectors = async (): Promise<Connector[]> => {
    const tools = await connectorService.getAvailableConnectors('all');
    return tools;
  }

  const syncUserConnectors = async (): Promise<{
    available: Connector[];
    userConnectors: UserConnectorListResponse;
  }> => {
    const { available, userConnectors } = await connectorService.syncUserConnectors();
    dispatch(setConnectors(userConnectors));
    return { available: available, userConnectors: userConnectors }
  }

  const getAvailableServerMcp = async (): Promise<Connector[]> => {
    const tools = await connectorService.getAvailableConnectors('mcp');
    return tools;
  }

  const registerConfluenceMcp = (id: string) => {
    const popup = outlookAuthService.registerConnectorPopup(id);
    if (popup) {
      // setAuthPopup(popup);
    } else {

      alert('팝업 차단을 해제해주세요.');
    }
    return;
  }

  const createConnector = async (connector: Connector) => {
    await connectorService.createConnector(connector);

  }

  const updateConnector = async (userConnector: UserConnector): Promise<UserConnector> => {
    const result = await connectorService.updateConnector(userConnector);
    dispatch(setConnector(result));
    return result;
  }

  const updateConnectorTool = async (connectorId: string, toolName: string, enabled: boolean): Promise<UserConnector> => {
    const result = await connectorService.updateConnectorTool(connectorId, toolName, enabled);
    const userConnector = store.getState().tools.connectors.data.find(c => c.id == connectorId);
    if (userConnector) {
      const updatedData = {
        ...userConnector,
        tools: userConnector?.tools?.map(tool =>
          tool.name === toolName
            ? { ...tool, enabled: !tool.enabled }
            : tool
        )
      };
      dispatch(setConnector(updatedData));
    }
    return result;
  }

  const deleteConnector = async (connectorId: string): Promise<boolean> => {
    await connectorService.deleteConnector(connectorId);
    // const connector = store.getState().tools.connectors.data.filter(c => c.id != connectorId);
    const connectors = store.getState().tools.connectors;
    const now = {
      ...connectors,
      data: connectors.data.filter(c => c.id != connectorId),
      totalCount: connectors.totalCount - 1
    };
    dispatch(setConnectors(now));
    return true;
  }

  return {
    changedMcpToolState,
    changedMcpServerState,
    getUserConnectors,
    getAvailableServerMcp,
    registerConfluenceMcp,
    syncUserConnectors,
    getAvailableConnectors,
    updateConnector,
    createConnector,
    deleteConnector,
    updateConnectorTool
  };
}